export default "__VITE_ASSET__Bu56sFky__"